import { useLogOutMutation } from "@/data/queries"
import { useAuthTokensAtom } from "@/data/store"
import { isTokenExpired } from "@/model/Jwt"
import { ROUTES } from "@/routes"
import { PropsWithChildren, useEffect } from "react"
import { useLocation, useNavigate } from "react-router"

const Auth = ({ children }: PropsWithChildren) => {
  const [authTokens] = useAuthTokensAtom()
  const navigate = useNavigate()
  const location = useLocation()
  const { mutate: logOut, isPending: isLoggingOut } = useLogOutMutation()

  useEffect(() => {
    // Refresh-token expiry: tell the backend the session is over (audit) AND
    // clear the query cache. setAuthTokens(null) alone doesn't drop cached
    // patient data — useLogOutMutation does both via its onSuccess hook.
    if (authTokens && isTokenExpired(authTokens.refreshJwt)) {
      logOut()
    }
    if (!authTokens) {
      navigate(ROUTES.SIGN_IN, { replace: true })
    }
  }, [navigate, authTokens, location, logOut])

  if (!authTokens || isLoggingOut) {
    return null
  }

  return children
}

export default Auth
